import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ProductForm, ProductsPageStates } from '../../typings/products';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { DirectFormInput } from '../DirectFormInput/DirectFormInput';
import { InputFieldType } from '../InputField/InputField';

import './ProductsAddForm.css';
import * as keyset from './ProductsAddForm.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'products-form';

interface ProductsFormProps {
    productsForm: ProductForm;
    pageStatus: ProductsPageStates;
    onAddProduct: (productName: string, description: string) => void;
    changeProductsForm: (productsFormData: ProductForm) => void;
}

export class ProductsAddForm extends React.Component<ProductsFormProps> {
    render() {
        const { pageStatus, productsForm } = this.props;
        const {
            product: { productName, description },
            isEnabled,
            isValid
        } = productsForm;

        if (isEnabled) {
            return (
                <div className={Bem.cls(BLOCK)}>
                    <div className={Bem.cls(BLOCK, 'section')}>
                        <span className={Bem.cls(BLOCK, 'label')}>{i18n('product-name-label')}</span>
                        <DirectFormInput
                            theme={'normal'}
                            size={'s'}
                            text={productName}
                            cls={Bem.cls(BLOCK, 'input')}
                            inputType={InputFieldType.TEXT}
                            valid={isValid}
                            errorText={i18n('error-text')}
                            disabled={pageStatus === ProductsPageStates.FETCH_FORM}
                            onChange={this.onProductNameChange}
                            placeholder={i18n('product-name-label')}
                        />
                    </div>
                    <div className={Bem.cls(BLOCK, 'section')}>
                        <span className={Bem.cls(BLOCK, 'label')}>{i18n('product-description-label')}</span>
                        <DirectFormInput
                            theme={'normal'}
                            size={'s'}
                            text={description}
                            cls={Bem.cls(BLOCK, 'textarea')}
                            inputType={InputFieldType.TEXTAREA}
                            valid={true}
                            hasClear={true}
                            disabled={pageStatus === ProductsPageStates.FETCH_FORM}
                            onChange={this.onDescriptionChange}
                            placeholder={i18n('product-description-label')}
                        />
                    </div>
                    <div className={Bem.cls(BLOCK, 'actions')}>
                        <ButtonDecorator
                            cls={Bem.cls(BLOCK, 'button')}
                            theme={'action'}
                            text={i18n('action-add')}
                            size={'s'}
                            progress={pageStatus === ProductsPageStates.FETCH_FORM}
                            onClick={this.onSave}
                            disabled={!isValid || !productName.trim()}
                        />
                        <ButtonDecorator
                            cls={Bem.cls(BLOCK, 'button')}
                            theme={'normal'}
                            text={i18n('action-cancel')}
                            size={'s'}
                            disabled={pageStatus === ProductsPageStates.FETCH_FORM}
                            onClick={this.toggleForm}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className={Bem.cls(BLOCK)}>
                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'button')}
                    theme={'action'}
                    text={i18n('action-add')}
                    size={'s'}
                    onClick={this.toggleForm}
                />
            </div>
        );
    }

    private toggleForm = () => {
        const {
            changeProductsForm,
            productsForm: { isEnabled }
        } = this.props;

        changeProductsForm({
            isEnabled: !isEnabled,
            product: { productName: '', description: '' },
            isValid: true
        });
    };

    private onProductNameChange = (productName: string) => {
        const { changeProductsForm, productsForm } = this.props;
        const {
            product: { description }
        } = productsForm;
        const pattern = /^[a-zA-Z-_]+$/g;

        productName = productName.trim();

        if (pattern.test(productName)) {
            changeProductsForm({
                ...productsForm,
                isValid: true,
                product: { productName, description }
            });
        } else {
            changeProductsForm({
                ...productsForm,
                isValid: false,
                product: { productName, description }
            });
        }
    };

    private onDescriptionChange = (description: string) => {
        const { changeProductsForm, productsForm } = this.props;
        const {
            product: { productName }
        } = productsForm;

        changeProductsForm({
            ...productsForm,
            product: { productName, description }
        });
    };

    private onSave = () => {
        const {
            onAddProduct,
            productsForm: { product }
        } = this.props;

        onAddProduct(product.productName, product.description);
    };
}
